"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadVerticalScript = exports.getVerticalSrc = exports.getVerticalRequest = void 0;
const errors_1 = require("./genericManual/errors");
const getVerticalRequest = (url) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch(url);
        if (response.ok) {
            const scriptText = yield response.text();
            if (!scriptText) {
                throw new Error(`Error vertical empty response. URL ${url}`);
            }
            return scriptText;
        }
        throw new Error(`Error vertical response. Status: ${response.status}. StatusText ${response.statusText}`);
    }
    catch (e) {
        throw new errors_1.GetVerticalError(e.message);
    }
});
exports.getVerticalRequest = getVerticalRequest;
const getVerticalSrc = (scriptText) => {
    try {
        const html = document.createElement('html');
        html.innerHTML = scriptText;
        const srcs = Array.from(html.getElementsByTagName('script'))
            .map(element => element === null || element === void 0 ? void 0 : element.src)
            .filter(src => !!src);
        if (!srcs || !srcs.length) {
            throw new Error('Source not found');
        }
        return srcs;
    }
    catch (e) {
        throw new errors_1.GetVerticalSrcError(e.message);
    }
};
exports.getVerticalSrc = getVerticalSrc;
const loadVerticalScript = (srcs, verticalId) => {
    return Promise.all(srcs.map((src, index) => {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.id = verticalId + index;
            script.onload = () => {
                resolve();
            };
            script.onerror = () => {
                reject(new errors_1.LoadScriptVerticalError());
            };
            document.head.appendChild(script);
        });
    }));
};
exports.loadVerticalScript = loadVerticalScript;
//# sourceMappingURL=utils.js.map